import React from 'react';
import { MailToLink } from '../FAQStyled';

export const FaqLinkToFormDoc = () => {
  return (
    <MailToLink href={'/files/71f5310d2e6256b9/Шаблон для актуализации ОУ в Кабинете региона и муниципалитета.xlsx'}>
      {'шаблон для заполнения'}
    </MailToLink>
  );
};
